<template>
  <div class="input-container"
       :style="props.style"
  >
    <button :type="props.type"
            class="btn"
            :class="{ 'disabled': props.disabled }"
            @click="buttonClicked"
    >
      <span v-if="props.materialIcon != '' "
            class="material-icons"
      >{{ props.materialIcon }}</span>
      {{ props.buttonText }}
    </button>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

const emit = defineEmits(['buttonClicked', 'saveItem'])

const props = defineProps({
  buttonText: {
    type: [String, Number],
    default () {
      return ''
    }
  },
  type: {
    type: String,
    default () {
      return 'button'
    }
  },
  materialIcon: {
    type: String,
    default () {
      return ''
    }
  },
  style: {
    type: String,
    default () {
      return ''
    }
  }
})

function buttonClicked () {
  emit('buttonClicked')
}
</script>

<style lang="scss" scoped>
.input-container{
    height: 100%;
    width: 100%;
}
.btn{
    transition: 0.2s ease-out;

    &:hover {
      transition: 0.2s ease-out;
      border-radius: 1rem 1rem;
      border: 2px solid black;
      background: white;
      color: var(--mainBlue);
    }

    font-size: 15px;
    outline: 0;
    border: 2px solid black;
    background: #f1f5f9;
    color: black;
    width: 100%;
    min-width:80px;
    height: 100%;
    padding: 4px;
    margin:0px 0px 15px 0px;
    text-transform: uppercase;
    border-radius: 2rem 2rem;

    &.disabled {
    background: rgb(199, 199, 199);
    opacity: 50;
    cursor: not-allowed;
  }
}
</style>
